/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { IDropdownStyles } from '@fluentui/react/lib/Dropdown';
import { IPivotStyles } from '@fluentui/react/lib/Pivot';
import { IStackStyles, IStackTokens } from '@fluentui/react/lib/Stack';
import { DarkColors } from '@msteams/components-fabric-teams-theme/dist/commonjs/src/teams/TeamsColors';

import { Theme } from '../../../common/enums/Theme';
import { ContrastColors, CoreColors } from '../../../styles/teams/TeamsColors';
import { getAppHost } from '../../../utilities/TeamsUtils';

export const getStackStyles = (): Partial<IStackStyles> => {
    return {
        root: {
            margin: '0.2625rem -0.5rem',
            selectors: {
                '> *': {
                    flex: '1 0 0',
                    margin: '0 0.5rem',
                },
            },
        },
    };
};

export const getMobileStackStyles = (): Partial<IStackStyles> => {
    return {
        root: {
            height: '100vh',
        },
    };
};

export const getStackTokens = (): Partial<IStackTokens> => {
    return {
        childrenGap: '0.5rem',
    };
};

export const getPivotStyles = (): Partial<IPivotStyles> => {
    // TODO: use conditional to check for themeName, and then choose the correct colors for theming
    const themeName = getAppHost().getTheme();
    const BACKGROUND_COLOR = 'transparent';

    let TEXT_COLOR = CoreColors.appBlack;

    if (themeName === Theme.Dark) {
        TEXT_COLOR = DarkColors.appBlack;
    } else if (themeName === Theme.Contrast) {
        TEXT_COLOR = ContrastColors.appBlack;
    }

    return {
        root: {
            border: 0,
            marginBottom: '1px',
            textAlign: 'start',
            selectors: {
                '.ms-Pivot-text': {
                    color: TEXT_COLOR,
                },
                '.ms-Button': {
                    padding: '0',
                    selectors: {
                        ':hover': {
                            background: BACKGROUND_COLOR,
                        },
                        '::before': {
                            left: '0px',
                            right: '0px',
                        },
                    },
                },
            },
        },
    };
};

export const getEsignProviderDropdownStyles = (): Partial<IDropdownStyles> => {
    const iconStyle = {
        selectors: {
            '.esign-provider-icon > svg': {
                width: '1.15em',
                height: '1.15em',
                marginRight: '0.6em',
                marginBottom: '-0.15em',
            },
        },
    };
    return {
        dropdownItems: iconStyle,
        title: iconStyle,
    };
};
